import React from 'react';
import classNames from 'classnames';

import css from './SectionWelcome.module.css';

/**
 * FairwayBid – die Wettersymbole
 *
 * Gezeichnet statt Emoji: Emoji sehen auf jedem System anders aus, tragen
 * die Farben ihres Herstellers und stehen schief in der Zeile. Sechs kleine
 * Formen sind schnell gezeichnet und gehören dann zum Rest der Seite.
 *
 * Sie sind bewusst schlicht - eine Wolke mit drei Strichen ist Regen. Wer
 * mehr Detail zeichnet, gewinnt nichts: Die Aussage ist "heute nass", nicht
 * "Nieselregen von Westen".
 */
const Sonne = () => (
  <>
    <circle className={css.iconSun} cx="16" cy="16" r="6.5" />
    {[0, 45, 90, 135, 180, 225, 270, 315].map(grad => (
      <line
        key={grad}
        className={css.iconRay}
        x1="16"
        y1="4.5"
        x2="16"
        y2="7.5"
        transform={`rotate(${grad} 16 16)`}
      />
    ))}
  </>
);

const Wolke = ({ x = 0, y = 0 }) => (
  <path
    className={css.iconCloud}
    transform={`translate(${x} ${y})`}
    d="M9.5 22.5h13a4.5 4.5 0 0 0 .4-9 6.5 6.5 0 0 0-12.2-1.6 4.3 4.3 0 0 0-1.2 10.6Z"
  />
);

const Tropfen = ({ versatz = 0 }) =>
  [10, 16, 22].map((x, i) => (
    <line
      key={x}
      className={css.iconDrop}
      x1={x}
      y1={25 + versatz}
      x2={x - 1.5}
      y2={29 + versatz}
      style={{ animationDelay: `${i * 0.25}s` }}
    />
  ));

const Flocken = () =>
  [10, 16, 22].map((x, i) => (
    <circle
      key={x}
      className={css.iconFlake}
      cx={x}
      cy={27}
      r="1.6"
      style={{ animationDelay: `${i * 0.3}s` }}
    />
  ));

const Blitz = () => (
  <path className={css.iconBolt} d="M17 24 L13 30 L16 30 L14 34 L20 27 L17 27 Z" />
);

const Nebelstriche = () =>
  [13, 18, 23].map((y, i) => (
    <line
      key={y}
      className={css.iconFog}
      x1={6 + (i % 2) * 2}
      y1={y}
      x2={26 - (i % 2) * 2}
      y2={y}
    />
  ));

/**
 * @param {string} symbol einer der Schlüssel aus weather.js (LAGEN)
 */
const WetterIcon = ({ symbol, className, titel }) => (
  <svg
    className={classNames(css.icon, className)}
    viewBox="0 0 32 36"
    role="img"
    aria-label={titel || undefined}
    aria-hidden={titel ? undefined : true}
  >
    {symbol === 'sonne' ? <Sonne /> : null}
    {symbol === 'heiter' ? (
      <>
        <circle className={css.iconSun} cx="21" cy="10" r="5" />
        <Wolke y={2} />
      </>
    ) : null}
    {symbol === 'wolke' ? <Wolke /> : null}
    {symbol === 'nebel' ? <Nebelstriche /> : null}
    {symbol === 'regen' ? (
      <>
        <Wolke />
        <Tropfen />
      </>
    ) : null}
    {symbol === 'schnee' ? (
      <>
        <Wolke />
        <Flocken />
      </>
    ) : null}
    {symbol === 'gewitter' ? (
      <>
        <Wolke />
        <Blitz />
      </>
    ) : null}
  </svg>
);

export default WetterIcon;
